import * as React from "react";
import { Routes, Route, Outlet, useNavigate } from "react-router-dom";
import Navbar from "react-bootstrap/Navbar";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from 'react-bootstrap/Form';
import Image from 'react-bootstrap/Image';

import "./App.scss";
import { auth, onAuthStateChanged } from '../src/thirdparty/firebaseInit';

import HomePage from "./pages/home";
import DashboardPage from "./pages/dashboard";
import AboutPage from "./pages/about";
import NoMatchPage from "./pages/nomatch";
import AppContext from "./components/app-context/AppContext";
import LinkContainer from "./components/link-container";
import Leftnav from "./components/leftnav";
import { parseImageUrl } from "./core/image-utils";
import { Icons } from "./components/icon/Icons";
import LoginPage from "./pages/login/LoginPage";
import LogoutPage from "./pages/logout/LogoutPage";
import TermsPage from "./pages/terms/TermsPage";
import PolicyPage from "./pages/policy/PolicyPage";

function App() {
  const [loggedInUser, setLoggedInUser] = React.useState(null);

  React.useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in, see docs for a list of available properties
        // https://firebase.google.com/docs/reference/js/firebase.User
        const uid = user.uid;
        setLoggedInUser({
          displayName: user.displayName,
          uid: user.uid,
          userId: uid,
        })
        // ...
      } else {
        // User is signed out
        // ...
      }
    });

    // If the component is unmounted, unsubscribe
    // from the event with the `off` method:
    return () => {
      // do something
    };
  }, []);

  return (
    <AppContext.Provider value={{
      version: "1.0.0",
      loggedInUser: loggedInUser,
    }}>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="login" element={<LoginPage />} />
          <Route path="logout" element={<LogoutPage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="policy" element={<PolicyPage />} />
          <Route path="*" element={<NoMatchPage />} />
        </Route>
      </Routes>
    </AppContext.Provider>
  );
}

function Layout() {
  const navigate = useNavigate();
  const expand = "lg";
  const [show, setShow] = React.useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { loggedInUser } = React.useContext(AppContext);

  const handleSearch = (searchKey) => {
    navigate("/search", {
    });
  }

  return (
    <div className="App">
      <Navbar
        bg="light"
        fixed="top"
        expand={expand}
        className="border-bottom"
      >
        <Container fluid>
          <LinkContainer to={"/"}>
            <Navbar.Brand href="#home">
              <img
                alt=""
                src="/logo.svg"
                width="30"
                height="30"
                className="d-inline-block align-top"
              />{' '}
              Now
            </Navbar.Brand>
          </LinkContainer>
          <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
          <Navbar.Offcanvas
            id={`offcanvasNavbar-expand-${expand}`}
            aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
            placement="start"
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                Offcanvas
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-start flex-grow-1 pe-3">
                <LinkContainer to="/">
                  <Nav.Link>Home</Nav.Link>
                </LinkContainer>
                <LinkContainer to="/about">
                  <Nav.Link>About</Nav.Link>
                </LinkContainer>
                <NavDropdown
                  title="Services"
                  id={`offcanvasNavbarDropdown-expand-${expand}`}
                >
                  <LinkContainer to="/services/services-1">
                    <NavDropdown.Item>Service 1</NavDropdown.Item>
                  </LinkContainer>
                  <LinkContainer to="/services/services-2">
                    <NavDropdown.Item>Service 2</NavDropdown.Item>
                  </LinkContainer>
                  <NavDropdown.Divider />
                  <NavDropdown.Item href="#action5">
                    Something else here
                  </NavDropdown.Item>
                </NavDropdown>
                <LinkContainer to="/others">
                  <Nav.Link>Others</Nav.Link>
                </LinkContainer>
              </Nav>
              <Form className="d-flex">
                <Form.Control
                  type="search"
                  placeholder="Search"
                  className="me-2"
                  aria-label="Search"
                />
                <Button 
                  variant="outline-success"
                  onClick={handleSearch}
                >
                  Search
                </Button>
              </Form>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          <Button
            variant="light"
            onClick={handleShow}
            className="ms-2"
          >
            <Icons.List />
          </Button>
          {!loggedInUser?.uid ?
            <LinkContainer to={"/login"}>
              <Button
                variant="light"
                className="ms-2"
              >
                <Icons.CircleSquare />
              </Button>
            </LinkContainer>
            : null
          }
          <NavDropdown
            id="basic-nav-dropdown"
            align={"end"}
            // title="Dropdown" 
            title={
              <Image
                src={parseImageUrl("/logo.svg")}
                alt="User image"
                width="32px"
                height="32px"
                // thumbnail={true}
                roundedCircle={true}
              />
            }
            className="ms-2"
          >
            <LinkContainer to="/profile">
              <NavDropdown.Item>Profile</NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/profile">
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
            </LinkContainer>
            <LinkContainer to="/settings">
              <NavDropdown.Item>Settings</NavDropdown.Item>
            </LinkContainer>
            <NavDropdown.Divider />
            <LinkContainer to="/logout">
              <NavDropdown.Item>Logout</NavDropdown.Item>
            </LinkContainer>
          </NavDropdown>
        </Container>
      </Navbar>
      <Offcanvas show={show} onHide={handleClose} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Settings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          Some text as placeholder. In real life you can have the elements you
          have chosen. Like, text, images, lists, etc.
        </Offcanvas.Body>
      </Offcanvas>
      <div className="Main d-flex">
        {!!loggedInUser?.uid ?
          <Leftnav
          />
          : null
        }
        <div className="p-3">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default App;
